import React, { useEffect, useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import SwitchField from "../../../components/Fields/SwitchField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { ItemTypePopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";

interface ItemTypeAttachmentType {
    itemTypeId: number
    attachmentTypeId: number
    visibleNew: boolean
    concurrencyId: string
}

const AddItemTypeAttachmentTypePopup: React.FC<ItemTypePopupProps> = ({ show, onHide, itemTypeId }) => {
    const [serverErrors, setServerErrors] = useState<DataResult<ItemTypeAttachmentType>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();
    const [formData, setFormData] = useState<ItemTypeAttachmentType>();

    const attachmentTypes = useSelectListOptions('api/v1/selectlist/AttachmentTypes', '-- Select attachment type');

    useEffect(() => {
        setFormData({
            itemTypeId: itemTypeId,
            attachmentTypeId: 0,
            visibleNew: false,
            concurrencyId: ''
        })
    }, [itemTypeId]);

    function submit() {
        if (formData) {
            DataService
                .create<ItemTypeAttachmentType>(`api/v1/AttachmentTypeItemTypes/`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true && onHide)
                        onHide()
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'attachmentTypeId', label: 'Attachment type', labelSize: 4, validationRules: [{ type: 'isRequired' }] },
            { name: 'visibleNew', label: 'Visible when creating a new item of this type', labelSize: 10 },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add attachment type'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('attachmentTypeId')} options={attachmentTypes} />
                <SwitchField {...getFieldProps('visibleNew')}  />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Add' />
            </Popup.Footer>
        </Popup>
    );
}
export default AddItemTypeAttachmentTypePopup;